import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.setupScrollReveal()
    this.setupNavScroll()
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
    if (this.scrollHandler) window.removeEventListener("scroll", this.scrollHandler)
  }

  setupScrollReveal() {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("revealed")
            this.observer.unobserve(entry.target)
          }
        })
      },
      { threshold: 0.1, rootMargin: "0px 0px -60px 0px" }
    )

    document.querySelectorAll(".reveal").forEach((el) => {
      this.observer.observe(el)
    })
  }

  setupNavScroll() {
    const nav = document.getElementById("landing-nav")
    if (!nav) return

    this.scrollHandler = () => {
      if (window.scrollY > 40) {
        nav.classList.add("bg-white/95", "shadow-sm")
        nav.classList.remove("bg-transparent")
      } else {
        nav.classList.remove("bg-white/95", "shadow-sm")
        nav.classList.add("bg-transparent")
      }
    }

    window.addEventListener("scroll", this.scrollHandler, { passive: true })
    this.scrollHandler()
  }

  toggleMobileMenu() {
    const menu = document.getElementById("mobile-menu")
    if (!menu) return
    menu.classList.toggle("hidden")
  }
}
